const LIQUID_ENGINE = 'liquid_engine';
const PPC_BADGE_TEST = 'ad_test';

/**
 * Whether or not a gig is considered a "rising talent".
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
export const isRisingTalent = (gigType = '') => gigType === LIQUID_ENGINE;

/**
 * Whether or not a gig is in the ppc ad badge test.
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
export const inPpcAdBadgeTest = (gigType = '') => gigType === PPC_BADGE_TEST;



// WEBPACK FOOTER //
// ./src/utils/gigTypes/index.js